import { NAME as APP_NAME } from 'constants';
import moment from 'moment';

const now = moment();
const startToday = now.startOf('day').toISOString();
const endToday = now.endOf('day').toISOString();

export const NAME = `${APP_NAME}/V2_DASHBOARD`;

export const ROUTES = {
  ROOT: '/masheed/dashboard',
};

export const REDUCER_NAME = 'V2_DASHBOARD';

export const COLORS = [
  '#F89F3D',
  '#E07A5F',
  '#74b181',
  '#b3d1b8',

  '#fad5b5',
  '#fcba7b',
  'rgba(234, 135, 96, 0.75)',
  'rgba(240, 93, 35, 1)',

  'rgba(239,35,60, 0.3)',
  'rgba(239,35,60, 0.5)',
  'rgba(239,35,60, 0.75)',
  'rgba(239,35,60, 1)',

  'rgba(61, 64, 91, 0.3)',
  'rgba(61, 64, 91, 0.5)',
  'rgba(61, 64, 91, 0.75)',
  'rgba(61, 64, 91, 1)',
];
